namespace TR {

    function Carousel(
        funcUtil,
        $timeout: ng.ITimeoutService
    )

    {
        return {
            scope: {
                data : '=',
                autoplay : '=',
                autoplaySpeed : '=',
                slidesToShow : '=',
                slidesToScroll : '=',
                arrows : '=',
                dots : '=',
                infinite : '=',
                asNavFor: '@',
                fade: '@',
                speed: '@',
                responsive: '=',
                variableWidth: '=',
                centerMode: '='
            },
            restrict: 'E',
            templateUrl: 'partials/home/directivetemplate?type=CarouselDirective',
            transclude: true,
            replace: true,
            link
        };

        function link($scope, $e) {

            $scope.fade = $scope.fade === 'true';
            $scope.speed = angular.isUndefined($scope.speed) ? undefined : parseInt($scope.speed, 10);

            const carousel:any = $e.find('.carousel-content');
            $scope.show = false;
            const DEFAULT_OPTIONS = {
                arrows: true,
                dots: false,
                autoplay: true,
                autoplaySpeed: 3000,
                pauseOnHover: true,
                rtl: TRPCONFIG.Rtl,
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: undefined,
                fade: undefined,
                speed: undefined,
                infinite: true,
                variableWidth: false,
                centerMode: false
            };

            // HEADSUP this has been set up to support 4 cards on TR
            const DEFAULT_RESPONSIVE = [
                {
                    breakpoint: 1023,
                    settings: { slidesToShow: 3, slidesToScroll: 3 }
                },
                {
                    breakpoint: 769,
                    settings: { slidesToShow: 2, slidesToScroll: 2 }
                }
            ];

            const options:any = _.assignWith(
                _.pick($scope, _.keys(DEFAULT_OPTIONS)),
                DEFAULT_OPTIONS,
                (opt, def) => _.isUndefined(opt) ? def : opt
            );

            options.autoplay = false;

            options.responsive = !$scope.responsive && parseInt(options.slidesToShow, 10) === 4
                ? DEFAULT_RESPONSIVE
                : $scope.responsive;

            funcUtil.waitForValue(() => !_.isEmpty(carousel[0].children) && carousel.is(':visible'))
                .then(() => $timeout(() => {
                    $scope.show = true;
                    carousel.slick(options);
                    $scope.$on('$destroy', () => carousel.slick('unslick'));
                }));
        }
    }

    angular
        .module('TR')
        .directive('carousel', Carousel);
}
